<template>
  <div class="notice-detail common-bg">
    <van-nav-bar fixed :title="pageTitle" left-arrow @click-left="$router.back()" />
    <div class="detail-wrap" :class="{ 'paomadeng-wrap': cateid === 11 }">
      <template v-if="cateid !== 11">
        <h1 v-if="notice.name" class="detail-title">{{ notice.name }}</h1>
        <div v-if="noticeTime" class="detail-time">{{ noticeTime }}</div>
      </template>
      <div class="detail-content" v-html="notice.content"></div>
      <div v-if="!notice.id && fallbackText" class="detail-content" v-html="fallbackText"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeDetail',
  data() {
    return {
      pageTitle: '公告详情',
      cateid: 9,
      notice: {},
      fallbackText: ''
    }
  },
  computed: {
    noticeTime() {
      const t = this.notice.stor || this.notice.created_at || this.notice.time || '';
      if (!t) return '';
      const d = new Date(t.replace ? t.replace(/-/g, '/') : t);
      if (isNaN(d.getTime())) return t;
      const p = n => n < 10 ? '0' + n : n;
      return d.getFullYear() + '/' + p(d.getMonth()+1) + '/' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
    }
  },
  created() {
    const query = this.$route.query || {};
    const cateid = query.cateid ? Number(query.cateid) : 9;
    this.cateid = cateid;
    if (cateid === 10) {
      this.pageTitle = '通知详情';
    } else if (cateid === 11) {
      this.pageTitle = '跑马灯详情';
    } else {
      this.pageTitle = '公告详情';
    }
    const id = query.id ? Number(query.id) : 0;
    if (id) {
      this.loadDetail(id);
    } else {
      this.fallbackText = query.text || '';
    }
  },
  methods: {
    loadDetail(id) {
      const that = this;
      that.$apiFun.post('/api/articledetail', { id }).then(res => {
        if (res.code === 200 && res.data) {
          that.notice = res.data;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-detail {
  min-height: 100vh;
  padding-top: 1.1rem;
  background: #0a0a0a;
  color: #fff;
  .detail-wrap {
    padding: 0.35rem 0.3rem;
  }
  .detail-wrap.paomadeng-wrap {
    padding-top: 0.2rem;
  }
  .detail-title {
    font-size: 0.4rem;
    line-height: 1.45;
    color: #fff;
    font-weight: 500;
    margin: 0 0 0.2rem 0;
    text-align: center;
  }
  .detail-time {
    font-size: 0.26rem;
    color: #888;
    text-align: center;
    margin-bottom: 0.35rem;
  }
  .detail-content {
    font-size: 0.3rem;
    line-height: 1.7;
    color: #DFB372;
    word-break: break-all;
    img { max-width: 100%; }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/noticeDetail.vue